import { IonSelect, IonSelectOption } from "@ionic/react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../store/rootReducer";
import { setFilterForFileTemplates } from "../../../store/templateList";

export const FilterFileTemplateList = () => {
    const dispatch = useDispatch();
    const filter = useSelector((state: RootState) => state.templateList.filterForFileTemplates);

    return (
        <>
            <IonSelect
                style={{ width: "50%" }}
                interface="popover"
                value={filter}
                onIonChange={({ detail: { value } }) => dispatch(setFilterForFileTemplates(value))}
            >
                <IonSelectOption value="all">Todos</IonSelectOption>
                <IonSelectOption value="location">Instalaciones</IonSelectOption>
                <IonSelectOption value="user">Usuarios</IonSelectOption>
            </IonSelect>
        </>
    )
}